import { createRouter } from '@tanstack/react-router';
import qs from 'qs';
import { DEFAULT_SERVER_BASE_PATH } from '@mews-commander/modules';
import { MAX_ARRAY_ITEMS_PARSE_COUNT } from '@mews/framework';
import { routeTree } from './routeTree.gen';

export const createTanStackRouter = (basePath = DEFAULT_SERVER_BASE_PATH) =>
    createRouter({
        routeTree,
        basepath: basePath,
        context: {
            /* eslint-disable @typescript-eslint/no-non-null-assertion */
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: undefined!,
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: undefined!,
            featureFlagService: undefined!,
            checkFeatureFlag: undefined!,
            checkPrivilege: undefined!,
            checkPlatformPrivilege: undefined!,
            ensureQueryData: undefined!,
            queryClient__DO_NOT_USE: undefined!,
            environment: undefined!,
            localizeText: undefined!,
            localizeProperty: undefined!,
            globalization: undefined!,
            /* eslint-enable @typescript-eslint/no-non-null-assertion */
        },
        stringifySearch: (search) => qs.stringify(search, { arrayFormat: 'repeat', addQueryPrefix: true }),
        parseSearch: (search) => qs.parse(search, { arrayLimit: MAX_ARRAY_ITEMS_PARSE_COUNT, ignoreQueryPrefix: true }),
    });

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof createTanStackRouter>;
    }
}
